"use strict";

var ACC;
ACC.checkoutsteps = {

    _autoload: [
        ["initClickAndCollect", $("#clickAndCollectStoreSelection").length],
        ["initCollectionPoint", $("#parcelShopContainer").length],
        "checkoutFormInit",
        "deliveryOption",
        "triggerPreselectedDeliveryEvent",
        "checkoutAddressFormValidation",
        "paymentFormInit",
        "voucherErrorCheck",
        "trackPostcodeError",
        "checkPromoCode",
        "bindBillingAddressSubmit",
        "bindBFCache",
        "bindAddAddressLinkHandlers",
        ["activateGiftCardTab", $("#gift-tab[data-activateonpageload='true']").length],
        ["clearSelectedStore", $(document.body).hasClass("page-orderConfirmationPage")],
        "checkAddressBillId",
        "removeParcelShopSessionDetails",
        "displayFlashBanner"
    ],

    // Store common lookups and reusable elements.
    _cache: {
        $storeSelectors: $(), // Replaced on the fly with addStoreSelectors()
        text: {} // Populated on the fly to hold JSP text from properties.
    },

    // Make it easy to find and unchanging change String values.
    _constants: {
        CLASS_VISIBLE: "visible",
        DATA_SELECTED_STORE: "selectCandCStore",
        SELECTOR_ADDRESS_FORM: "#tjxAddressForm",
        SELECTOR_CLICK_AND_COLLECT: "[data-node='clickandcollect']",
        SELECTOR_HOME_DELIVERY: "[data-node='homedelivery']",
        SELECTOR_HOME_DELIVERY_DETAILS: "[data-node='homeDeliveryDetails']",
        SELECTOR_PARCEL_SHOP: "[data-node='parcelshop']",
        SELECTOR_PARCEL_SHOP_BLOCK: ".checkout-parcel-shop",
        SELECTOR_STORE_SEARCH: "[data-node='clickAndCollectStoreSelection']",
        SELECTOR_CANDC_DETAILS: "[data-node='collectionDetailsForm']",
        SELECTOR_CANDC_DETAILS_BUTTON: "#collectionDetailsFormSubmit",
        SELECTOR_CANDC_DETAILS_FORM: "[data-node='collectionDetailsForm'] form",
        SELECTOR_CP_DETAILS_FORM: "[data-node='cpCollectionDetailsForm'] form",
        SELECTOR_CP_DETAILS_BUTTON: "#cpCollectionDetailsFormSubmit",
        SELECTOR_STORE_FINDER_LIST: "#storeFinderList",
        SELECTOR_GIFT_TAB: "#gift-tab",
        SELECTOR_PROMO_SECTION: "#promoSection",
        SELECTOR_SELECTED_STORE: "[data-node='collectionDetailsForm'] [name='storeName']",
        SELECTOR_SELECTED_DELIVERY_TYPE: "[data-node='collectionDetailsForm'] [name='deliveryType']",
        STORES_LIST_VIEW_LIMIT: 3,
        CHECKOUT_SUMMARY_BOX: ".checkout-order-summary-container  #globalMessages"
    },

    bindEnterKeypress: function() {
        $('label.add-address-left-label, .tkmaxxPreferences label, .homesensePreferences label, .payment-info-label, .payNewCardCta').on('keypress', function(e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                $(this).find('input').trigger('click');
            }
        });

        $('label[for="payWithNewCard"]').on('keypress', function(e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                $('input#payWithNewCard').trigger('click');
                $('input#payWithNewCard').addClass('checked').attr('checked', true);
                $('.payment-info-checkboxes .saveCard').show();
            }
        });

        $(document).on('keypress', 'label:focus, div:focus, input:focus, a:focus, li:focus', function(e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                $(this).trigger('click');
            }
        });
    },
    checkoutFormInit: function() {

        $(document).on("click",".checkout-steps .js-next",function(e) {
            e.preventDefault();
            $(this).parents(".step-body").next().click();
            if($(this).data("next")) {
                var step = $(this).data("next");
                var href = window.location.href;
                var nhref = href.replace(new RegExp(/step./), "step"+step);
                if(!window.location.hash) {
                    nhref = nhref + "#step"+step;
                } else {
                    nhref = nhref.replace(new RegExp(/#.*/), "#step"+step);
                }
                window.location = nhref;
            }
        });


        $('#tjxAddressForm').on('click','.billing-checkbox', function(e) {
            if($('#saveDeliveryAsBillingAddressID').is(":checked") === true) {
                ACC.gtm.trackCheckoutStepOptions('1', 'Setting billing address to delivery address');
            }
        });

    },

    checkoutOrderDetails: function($form, callback) {
        const initialAmount = $('.order-summary-total-amount').html();
        const formData = $($form).find('select, input').serialize();
        $.ajax({
            url : ACC.config.encodedContextPath + '/checkout/multi/delivery-method/checkoutOrderDetails',
            data: formData,
            type: 'POST',
            dataType : "html"
        }).done(function(data) {
            /**
             * If the response from the server does contain 'page-checkout-login' class
             * then this a wrong response coming as a result of redirect to the log page.
             * We will forward to checkout to handle any session timeout which requires hard login.
             */
            if(data.indexOf("page-checkout-login") != -1) {
                window.location.reload(true);
            }

            if(data.indexOf("page-gigyaDownErrorTkmaxxPage") != -1) {
                window.location.href=ACC.config.contextPath + "/session-error";
            }

            typeof callback === "function" ? callback() : {};
            $('.checkout-order-summary-holder').html(data);
            ACC.checkout.summaryViewAdjustment();
            ACC.checkoutsteps.checkGifCardError();
            const updatedAmount = $('.order-summary-total-amount').html();
            if (initialAmount !== updatedAmount) {
                ACC.checkoutsteps.setFlashBannerTimer();
            }
        }).fail(function(jqXHR) {
            /**
             * If the response from the server is anything but 200 we hard
             * refresh the page to allow the server to handle any re-directs.
             */
            if (jqXHR.status !== 200) {
                window.location.reload(true);
            }
        });
    },

    enableProceedBtn: function() {
        if ($(".checkout-delivery-address-block__initial-selection:visible").length > 0) {
            $("#deliveryMethodSubmit").prop('disabled', false);
        }
    },

    bindDeliveryOptionClickHandler: function() {
        var CS = ACC.checkoutsteps;
        $('.checkout-delivery-option-list').on('click', 'li', function(e){
            e.preventDefault();
            $("#deliveryMethodSubmit").prop('disabled', true);

            var $thisLi = $(this),
                $delLists = $('.checkout-delivery-option-list li');

            if($thisLi.find('input[type="radio"]').prop('checked') === false){
                var deliveryOptionLabel = $thisLi.find('input[type="radio"]').data('deliveryname');
                ACC.gtm.trackCheckoutStepOptions('1', deliveryOptionLabel);

                $delLists.removeAttr('aria-checked');
                $delLists.find('input[type="radio"]').removeAttr('checked', 'checked');
                $delLists.find('input[type="radio"]').prop('checked', false).removeClass('checked');
                $thisLi.find('input[type="radio"]').attr('checked', 'checked');
                $thisLi.find('input[type="radio"]').prop('checked', true).addClass('checked');
                $thisLi.attr('aria-checked', true)
            } else {
                $thisLi.find('input[type="radio"]').attr('checked', 'checked');
                $thisLi.find('input[type="radio"]').prop('checked', true).addClass('checked');
            }

            var $form = $("#tjxAddressForm");
            CS.checkoutOrderDetails($form, CS.enableProceedBtn);
        });
    },

    resetParcelShopDeliveryMethod: function() {
        var $parcelShopMethodContainer = $('.delivery-parcel-shop')
        $parcelShopMethodContainer.find('input[type="radio"]').removeAttr('checked', 'checked');
        $parcelShopMethodContainer.find('input[type="radio"]').prop('checked', false).removeClass('checked');
        $('.checkout-parcel-shop').slideUp();
    },

    bindAddAddressLinkHandlers: function() {
        var CS = ACC.checkoutsteps;
        $('#addressbook-registered').on('click', '#addNewAddressCTA', function(e){
            $('#saveDeliveryAsBillingAddressID').prop('checked',true);
        });

        $(document).ready(function () {
            var $radioInput = $('.checkout-delivery-option-list input[type="radio"]')
            // Set aria-checked attribute on page load for the specific ul
            $radioInput.each(function () {
                updateAriaChecked($(this));
            });

            // Update aria-checked attribute on radio button change within the specific ul
            $radioInput.change(function () {
                updateAriaChecked($(this));
            });

            function updateAriaChecked($radio) {
                // Set aria-checked attribute on the parent li of the selected radio
                if (!$radio.is(':checked')) {
                    $radio.closest('li').removeAttr('aria-checked');
                } else {
                    $radio.closest('li').attr('aria-checked', true);
                }
            }
        });

        $('.checkout-steps').on('click', '.address-loadmore-link', function(e) {
            e.preventDefault();
            var $this = $(this),
                $modal = $('.modal');

            $this.hide();
            $this.next('.address-loadmore-block').addClass('open').slideDown();
            $('#saveDeliveryAddressCTA').addClass('open').slideDown();
            $('.mandatory-star').hide();
            $('.add-billing-adr-button').show();

            if ($modal.hasClass('in') && $this.parents('.modal')) {
                $('.billing-checkbox').show();
                $('.change_address_button').show();
                $('#addressform_button_panel').show();
                $('#billingform_button_panel').show();
            }

            if($this.parents('.checkout-delivery-home')) {
                var $hasDelOptionBox = $('.checkout-delivery-home .checkout-delivery-option-block').is(':visible');
                if (!$hasDelOptionBox) {
                    CS.triggerPreselectedDeliveryOption();
                }
            }
            ACC.gtm.trackCheckoutStepOptions(1, 'Manual Address Selection');
        });

		$(".checkout-delivery-address-block").on('click', '#addNewAddressCTA', function() {
			ACC.validation.preventNonPhoneInput($("input[type=tel]", this));
			ACC.validation.handlePostcodeValidation($("#checkout-delivery-add-address").find("input[id=address-postcode]"));
            ACC.checkoutsteps.trackPostcodeError();

			if($('#checkout-delivery-add-address .form-group').hasClass('.has-error')){
				$('.billing-checkbox').show();
				$('#addressform_button_panel').show();
			}

			if($('.address-loadmore-block').hasClass('open')){
				$('.address-loadmore-link').hide();
				$('.billing-checkbox').show();
				$('#addressform_button_panel').show();
				$('.checkout-container .modal .change_address_button').css('display', 'inline-block');
			}
		});

		$("#wpPaymentDetailsFormPlaceHolder, #tjxPaymentDetailsFormPlaceHolder").on('click', "#addNewAddressCTA", function() {
			ACC.validation.preventNonPhoneInput($("input[type=tel]", this));
			ACC.checkoutsteps.deliveryOption();
            ACC.checkoutsteps.trackPostcodeError();

			if($('.address-loadmore-block').hasClass('open')){
				$('.address-loadmore-link').hide();
				$('#billingform_button_panel').show();
			}
		});
    },

    deliveryOption: function() {
        var CS = ACC.checkoutsteps;
        var cache = CS._cache;
        var c = CS._constants;
        var candc = cache.$storeSearch ? cache.$storeSearch.hasClass(c.CLASS_VISIBLE) : false;
        var noclickcollect = $('input[name="noclickandcollect"]').val();
        if (noclickcollect === 'false'){
            if($(".clickandcollect-warning").is(":visible")){
                $(".clickandcollect-warning").hide();
            }

            if($('.checkout-delivery-address-list li').find('input[name="deliveryAddress"]').length > 0){
                $('#saveDeliveryAsBillingAddressID').prop('checked',false);
            }

              $(document).ready(function() {
                // Function to set aria-checked attribute based on the initially checked radio button
                function setInitialAriaChecked() {
                  $('.delivery-option').each(function() {
                    const isChecked = $(this).find('input').prop('checked');
                    isChecked ? $(this).attr('aria-checked' ,true) : $(this).removeAttr('aria-checked');
                  });
                }

                // Attach click event to all radio buttons with class 'delivery-option'
                $('.delivery-option').click(function() {
                  // Remove 'aria-checked' attribute from all radio buttons
                  $('.delivery-option').removeAttr('aria-checked');

                  // Set 'aria-checked' attribute to 'true' for the selected radio button
                  $(this).attr('aria-checked', true);
                });

                // Set the initial state on document ready
                setInitialAriaChecked();
              });

            $('.checkout-shipping').on('click', '.delivery-box', function(e){
                e.preventDefault();
                var $thisBox = $(this),
                    $delBox = $('.delivery-box'),
                    $radioInput = $thisBox.find('input[type="radio"]'),
                    $deliveryLists = $('.checkout-delivery-option-list li'),
                    $thisElem = $(this)[0];

                var $proceed_btn = $("#deliveryMethodSubmit");
                $proceed_btn.prop('disabled', true);

                for (const element of $delBox) {
                    if (element !== $thisElem) {
				        element.removeAttribute('aria-checked');
                    }
                }

                if($radioInput.prop('checked') === false){
                    $delBox.find('input[type="radio"]').removeAttr('checked', 'checked');
                    $delBox.find('input[type="radio"]').prop('checked', false);
                    $delBox.removeClass('selected');

                    $radioInput.attr('checked', 'checked');
                    $radioInput.prop('checked', true);
                    $thisBox.addClass('selected');
                    $thisBox.attr('aria-checked', true)
                }
                if($thisBox.hasClass('delivery-home')){
                    $('#clickAndCollectStoreSelection').slideUp();
                    $('.checkout-parcel-shop').slideUp();
                    $('.checkout-delivery-home').slideDown();

                    /* To whomever will come and work here and is as confused as I was :)
                        - By design, when you first click delivery, if no delivery option is selected,
                            the first one should become selected and logged into datalayer together with
                            the 'delivery' event.
                        - If you switch to click&collect and then back to delivery, the prev selected
                            option should be logged into datalayer together with the 'delivery' event.
                            If the second del option is selected, it should not be overwritten, instead
                            it should be logged into datalayer together with the 'delivery' event.
                        - Before this fix, for some reason, nobody raised the issue of the delivery option
                            not being logged into datalayer upon delivery -> click&collect -> delivery
                    */
                    ACC.gtm.trackCheckoutStepOptions('1', 'delivery');
                    if ($deliveryLists.find('input[name="shippingMethodCode"]:checked').length <= 0) {
                       var $firstDelOptionListRadio = $deliveryLists.find('input[name="shippingMethodCode"]').first();
                       $firstDelOptionListRadio.attr('checked', 'checked');
                       var preselectedOption = $firstDelOptionListRadio.data('deliveryname');
                       ACC.gtm.trackCheckoutStepOptions('1', preselectedOption);
                    } else {
                       var $deliveryOptionRadio = $deliveryLists.find('input[name="shippingMethodCode"]:checked').first();
                       var selectedOption = $deliveryOptionRadio.data('deliveryname');
                       ACC.gtm.trackCheckoutStepOptions('1', selectedOption);
                    }
                    $('.checkout-delivery-home .checkout-proceed-btn').show();
                } else if ($thisBox.hasClass('delivery-store')){
                    $('.checkout-delivery-home').slideUp();
                    $('.checkout-parcel-shop').slideUp();
                    $('#clickAndCollectStoreSelection').slideDown();
                    ACC.gtm.trackCheckoutStepOptions('1', 'click and collect');
                } else {
                    $('.checkout-delivery-home').slideUp();
                    $('#clickAndCollectStoreSelection').slideUp();
                    $('.checkout-parcel-shop').slideDown();
                    ACC.gtm.trackCheckoutStepOptions('1', 'parcel shop');
                }

                var $form = $("#tjxAddressForm");
                if ($('.checkout-delivery-address-list li').length > 0) {
                    CS.checkoutOrderDetails($form, CS.enableProceedBtn);
                } else {
                    CS.checkoutOrderDetails($form, '');
                }

                //Assign value to hidden deliveryType
                cache.$selectedDeliveryType.val($radioInput.val());

            });
        } else if (noclickcollect === 'true') {
            $('.delivery-box.delivery-store').addClass('notavailable');
            $('.delivery-box.delivery-parcel-shop').addClass('notavailable');
            $('#clickAndCollectStoreSelection').hide();
            $('.checkout-delivery-home').show(0);

            $('.checkout-shipping').on('click', '.delivery-box.delivery-home', function(e) {
                e.preventDefault();
                var $thisBox = $(this),
                    $radioInput = $thisBox.find('input[type="radio"]');
                $radioInput.attr('checked', 'checked');
                $radioInput.prop('checked', true);
                $thisBox.addClass('selected');
                $('.checkout-delivery-home').slideDown();
                $(".clickandcollect-warning").show();
            });
            $('.checkout-shipping').on('click', '.delivery-box.delivery-store, .delivery-box.delivery-parcel-shop', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });
            $('.delivery-box.delivery-home').trigger('click');
        }

        if($('.delivery-box.delivery-home input#home').prop('checked') === true && $('.checkout-delivery-option-list li input:checked').length < 1) {
            $('.checkout-delivery-option-list li:nth-child(1) input').trigger('click');
        }

        $('.checkout-shipping .delivery-box').find('input[type="radio"]').each(function(){
            if($(this).attr('checked')){
                $(this).closest('.delivery-box').addClass('selected');
            }
        });

        if($('.checkout-billing-address-list li').length){
            var addressListLength = $('.checkout-billing-address-list li').length.toString();
            sessionStorage.setItem('addressListLength', addressListLength);
        }

        $('.checkout-billing-address-list').on('click', 'li', function(e){
            sessionStorage.setItem('selectedBillingAddressId', $(this).find('input').val());
        });

        if($('.template-pages-MultiStepCheckoutSummaryPageTemplate').find('.alert-danger').length !== 0 && !candc) {
            $('.checkout-delivery-home').show();
            $('.checkout-delivery-home .checkout-proceed-btn').show();

            var $delBox = $('.delivery-box');
            $delBox.each(function(){
                var $thisBox = $(this);
                if($thisBox.find('input[type="radio"]').is(':checked')){
                    $thisBox.addClass('selected');
                }
            });
        }

        // this should only apply for users with no prior saved addresses
        if($('div:not(.modal-body) > #i18nAddressForm .form-group').hasClass('has-error') === true){
            $('.address-loadmore-block').addClass('open');
            $('.address-loadmore-block').show();
            if($(this).parents('.checkout-delivery-home')){
                var storageAddressListLength = sessionStorage.getItem('addressListLength');
                if(storageAddressListLength < 2) {
                    $('#saveDeliveryAsBillingAddressID').prop('checked',true);
                }
            }
        }
        $('.user-billing-address').on('click', 'li.addressEntry', function(e){
            e.preventDefault();

            var $thisLi = $(this),
            $delLists = $('.user-billing-address li');


            if($thisLi.find('input[type="radio"]').prop('checked') === false){
                $delLists.find('input[type="radio"]').removeAttr('checked', 'checked');
                $delLists.find('input[type="radio"]').prop('checked', false).removeClass('checked');
                $thisLi.find('input[type="radio"]').attr('checked', 'checked');
                $thisLi.find('input[type="radio"]').prop('checked', true).addClass('checked');
            } else {
                $thisLi.find('input[type="radio"]').attr('checked', 'checked');
                $thisLi.find('input[type="radio"]').prop('checked', true).addClass('checked');
            }

            if($thisLi.find('input[type="radio"]').attr('data-default-address') === 'true'){
                $('#makeMyDefaultBillingAddress').hide();
            } else {
                $('#makeMyDefaultBillingAddress').show();
                var addressBillId = $thisLi.find('input').val();
                Cookies.set('addressBillId', addressBillId);
            }

        });

        if($('.checkout-terms .form-group').length > 0){
            var tkmaxxOptIn = $('#billingaddress-tkmaxxOptIn').val(),
                homesenseOptIn = $('#billingaddress-homesenseOptIn').val(),
                $tkCheckbox = $('#tkmaxxPreferences'),
                $homeCheckbox = $('#homesensePreferences');

            if(typeof tkmaxxOptIn === "undefined") {
                tkmaxxOptIn = false;
            }
            if(typeof homesenseOptIn === "undefined") {
                homesenseOptIn = false;
            }

            if(String(tkmaxxOptIn) === "false"){
                $tkCheckbox.removeAttr('checked', 'checked');
                $tkCheckbox.prop('checked', false);
                $tkCheckbox.parent().removeClass('checked');
            } else {
                $tkCheckbox.attr('checked', 'checked');
                $tkCheckbox.prop('checked', true);
                $tkCheckbox.parent().addClass('checked');
            }

            if(String(homesenseOptIn) === "false"){
                $homeCheckbox.removeAttr('checked', 'checked');
                $homeCheckbox.prop('checked', false);
                $homeCheckbox.parent().removeClass('checked');
            } else {
                $homeCheckbox.attr('checked', 'checked');
                $homeCheckbox.prop('checked', true);
                $homeCheckbox.parent().addClass('checked');
            }

            $('.tkmaxxPreferences').on('click', 'label', function(){
                if ($tkCheckbox.is(":checked")){
                    $('input#billingaddress-tkmaxxOptIn').val(true);
                } else {
                    $('input#billingaddress-tkmaxxOptIn').val(false);
                }
            });

            $('.homesensePreferences').on('click', 'label', function(){
                if ($homeCheckbox.is(":checked")){
                    $('input#billingaddress-homesenseOptIn').val(true);
                } else {
                    $('input#billingaddress-homesenseOptIn').val(false);
                }
            });

        }
    },

    checkoutAddressFormValidation: function() {

        ACC.validation.applyInputEmptyIndicators(
            $('#tjxAddressForm input, #tjxWpBillingAddressForm input, #tjxBillingAddressForm input, #worldPayBillingAddressForm input, #tjxPaymentsBillingAddressForm input')
            .filter("[type=text], [type=tel]").filter("[id!=address-postcode]")
        );
        ACC.validation.handlePostcodeValidation(
            $('#tjxAddressForm input, #tjxWpBillingAddressForm input, #tjxBillingAddressForm input, #worldPayBillingAddressForm input, #tjxPaymentsBillingAddressForm input')
                .filter("[id=address-postcode]")
        );
        $(".checkout-steps select[data-error]").focus(function () {
            }).blur(function () {
                var $parentClass = $(this).closest(".form-group");
                var errorMsg = $(this).data('error');
                 if ($(this).val() === null) {
                     if ($parentClass.find('i').length > 0) {
                         $parentClass.find('i').remove();
                    }

                    var divStr = "<div class=\"help-block\"><span>" +  errorMsg + "</span></div>";
                    $(this).closest(".controls").prepend('<i class="icon icon-cancel-circled error"></i>');
                     if ($parentClass.find('div.help-block').length === 1) {
                         $parentClass.find('div.help-block span').html('');
                         $parentClass.addClass('has-error');
                     } else {
                         $parentClass.append(divStr);
                         $parentClass.addClass('has-error');
                     }
                 }
         });

         $('.checkout-steps select[data-error]').change(function (){
             var $parentClass = $(this).closest(".form-group");
             if ($(this).val !== "") {
                if ($parentClass.find('i').length > 0){
                    $parentClass.find('i').remove();
                }

                if ($parentClass.find('div.help-block').length === 1) {
                     $parentClass.find('div.help-block span').html('');
                     $parentClass.removeClass('has-error');
                     $(this).closest(".controls").prepend('<i class="tick icon icon-check-circle"></i>');
                 }  else {
                     $(this).closest(".controls").prepend('<i class="tick icon icon-check-circle"></i>');
                 }

                 $parentClass.find('select').removeClass('select-default-color');
             }
         });

         if($('.global-alerts').length) {
             $('.global-alerts').each(function(item){
                if($(this).data('error-key') === 'checkout.nocandc') {
                    return;
                }
                var $input = $('#tjxAddressForm').find('input');
                $('.checkout-delivery-add-address .address-loadmore-block').show();
                $input.each(function() {
                   $(this).blur();
                });
             });
         }
    },

    paymentFormInit: function() {
        var updateRemoveButtons = function() {
            var $visibleGiftCardItems = $('.gift-card-form-item--visible');

            if ($visibleGiftCardItems.length > 1) {
                $visibleGiftCardItems.addClass('has-remove-btn');
            } else {
                $visibleGiftCardItems.removeClass('has-remove-btn');
            }
        };

        this.initGiftCardHandlers();
        updateRemoveButtons();
        handlePinIconVisibility();

        $('.payment-promo-code-link').click(function(e) {
            e.preventDefault();
            var $promoDiv = $('#promoSection');
            var $iconObj = $(this).find('.icon');
            if ($promoDiv.is(':hidden') === true) {
                var $voucherTab = $("#voucherTab");
                var $voucherTabs = $("#voucherTabs");
                $voucherTabs.find("li.checkout-voucher-tab").removeClass('active');
                $voucherTabs.find("li.checkout-gift-tab").removeClass('active');
                $voucherTabs.find("li.checkout-voucher-tab").addClass('active');
                $voucherTab.removeClass('active in');
                $("#giftTab").removeClass('active in');
                $voucherTab.addClass('active in');
                $promoDiv.slideDown('fast', function() {
                    $iconObj.removeClass('icon-down-open-mini').addClass('icon-up-open-mini');
                });

                ACC.gtm.trackCheckoutStepOptions('2', 'Got-PromoCode-GC Selection');
                ACC.gtm.trackCheckoutStepOptions('2', 'PromoCode Tab Selection');
            } else {
                $promoDiv.slideUp('fast', function(){
                    $iconObj.removeClass('icon-up-open-mini').addClass('icon-down-open-mini');
                });
            }
        });

        $('#promotion-tab-button').on('click', function() {
            if($('#promotion-tab-button').attr('aria-expanded') == 'false') {
                ACC.gtm.trackCheckoutStepOptions('2', 'PromoCode Tab Selection');
            }
        });


        $('#gift-card-tab-button').on('click', function() {
            if($('#gift-card-tab-button').attr('aria-expanded') == 'false') {
                ACC.gtm.trackCheckoutStepOptions('2', 'GiftCard Tab Selection');
            }
        });

        function handlePinIconVisibility() {
            $('.gift-card-form-item--visible').find('.gift-card-pin #where-is-pin').hide();
            $('.gift-card-form-item--visible').first().find('.gift-card-pin #where-is-pin').show();
        }

        $(document).on("click","#addGiftCard",function(e){
             e.preventDefault();

             var allowedCardsLimit = parseInt($("#giftCardMaxAllowedLimit").val());
             var numOfVisibleCards = $("div[id^='div-giftCard-']:visible").length;
             if(allowedCardsLimit > 0){
                 //Get first hidden gift card id
                 var divId = $("div[id^='div-giftCard-']:hidden").first().attr("id");
                 var newcardDivIndex = divId.substring(divId.lastIndexOf("-")+1);
                 $("#div-giftCard-"+newcardDivIndex).show().addClass('gift-card-form-item--visible');
                 $("#input-giftCard-valid-"+newcardDivIndex).val(true);
                 allowedCardsLimit = (allowedCardsLimit-1);
                 numOfVisibleCards = (numOfVisibleCards+1);
                 $("#giftCardMaxAllowedLimit").val(allowedCardsLimit);
                 $(".gift-card-payment-buttons").removeClass('hide').show();

                 updateRemoveButtons();
                 handlePinIconVisibility();
             }

            if(numOfVisibleCards > 0){
                 var applyText = $(".cards-apply").val();
                 $("#applyButton").text(applyText).val(applyText).attr('title', applyText);
            }
            if(allowedCardsLimit < 1){
                 $(this).hide();
             }

        });

        $(document).on("click", ".remove-gift-card-button", function() {
             var removeID = $(this).data('remove'),
                            $parent = $("#" + removeID),
                            allowedCardsLimit = parseInt($("#giftCardMaxAllowedLimit").val()),
                            numOfVisibleCards = $("div[id^='div-giftCard-']:visible").length;

             if($parent.length > 0) {
                 // Clear errors from form and reset form inputs
                 $parent.find('.form-group').removeClass('has-error');
                 $parent.find('.help-block').remove();
                 $parent.find('.icon-check-circle').remove();
                 $parent.find('.form-control').val('');
                 var valid = $parent.find('[id^=input-giftCard-valid]')
                 $(valid).attr('value', false);
                 $parent.hide().removeClass('gift-card-form-item--visible has-remove-btn');
                 allowedCardsLimit = (allowedCardsLimit+1);
                 numOfVisibleCards = (numOfVisibleCards-1);
                 $("#giftCardMaxAllowedLimit").val(allowedCardsLimit);
                 $("#addGiftCard").show();

                 updateRemoveButtons();
                 handlePinIconVisibility();
             }

             if (0 === numOfVisibleCards) {
                $(".gift-card-payment-buttons").addClass('hide');
             }

         });

         if (0 === parseInt($("#giftCardMaxAllowedLimit").val())) {
            $("#addGiftCard").hide();
         }

         $(document).on("submit","#newGiftCard, #checkBalanceGiftCardForm",function(e) {
             $(window).scrollTop(0);
             $('html').addClass('disable-scroll');
             $('.spinner-background').show();
         });

         if ($('#checkBalance').val() === 'true' && $('.global-alerts').length <= 0) {
                $('#gift-card-modal').modal('show');
                var applyText = $(".cards-apply").val();
                if ($("#giftCardNumber-1").val() > 0 ) {
                   $(".checkBalanceApplyButton").val(applyText).attr('title', applyText);
                }
         }
         // ERROR Gift Card Number - send to dataLayer
         if ($('#checkBalance').val() === 'false' && $("input[id^='giftCardNumber-']").hasClass('form-error')) {
            var giftNumberMain = document.querySelector('.gift-card-number');
            var giftNumberError = document.querySelector('.help-block');
            if (giftNumberMain.contains(giftNumberError) === true){
                ACC.gtm.callWhenLoaded( 'trackCheckoutErrorGTM' , 'GC_Invalid_Gift_Card');
            }
         }
         // ERROR Gift Card PIN Number - send to dataLayer
         if ($('#checkBalance').val() === 'false' && $("input[id^='giftCardPin-']").hasClass('form-error')) {
            var pinMain = document.querySelector('.gift-card-pin');
            var pinError = document.querySelector('.help-block');
            if (pinMain.contains(pinError) === true){
                ACC.gtm.callWhenLoaded( 'trackCheckoutErrorGTM' , 'GC_Invalid_Gift_Card_Pin' );
            }
         }
         // ERROR Recaptcha - send to dataLayer
         if ($('#checkBalance').val() === 'false' && $("#recaptcha").hasClass('has-error-border')) {
            ACC.gtm.callWhenLoaded( 'trackCheckoutErrorGTM' , 'GC_Invalid_Recaptcha' );
         }

         $(document).on("click",".checkBalanceApplyButton",function(e){
             e.preventDefault();
             if($(".gift-card-balance-checkbox input[type=checkbox]").is(':checked')) {
                var giftCardUrl = $("#giftCardUrl").val();
                 $('#checkBalanceGiftCardForm').attr('action', giftCardUrl);
                 $('#checkBalanceGiftCardForm').submit();
             }
             else {
                 $('#gift-card-modal').modal('hide');
             }
         });

         $('#gift-card-modal').on('hidden.bs.modal', function (e) {
            e.preventDefault();
            if($(".gift-card-balance-checkbox input[type='checkbox']").is(':checked')) {
                var numOfVisibleCards = $("div[id^='div-giftCard-']:visible").length;
                 if(numOfVisibleCards > 0){
                     var removeCheckBalanceGiftCardUrl = $("#removeCheckBalanceGiftCardUrl").val();
                     $('#checkBalanceGiftCardForm').attr('action', removeCheckBalanceGiftCardUrl);
                     $('#checkBalanceGiftCardForm').submit();
                 }
            }
         });

        $(document).on('click', '#where-is-pin', function () {
            var pinTooltip = $('.gift-card-pin-message');
            $(this).closest('.gift-card-form-item').find(pinTooltip).show();

            // Close the tooltip only if clicked on the close button or anywhere outside the pin message
            function handleTooltipClose(e) {
                var matched = false;
                var tooltipWrap = '.gift-card-pin-message, .gift-card-pin-message p';
                if (!Element.prototype.matches) {
                    // Handle IE
                    matched = e.target.msMatchesSelector(tooltipWrap);
                } else {
                    matched = e.target.matches(tooltipWrap)
                }
                if (!matched) {
                    pinTooltip.hide();
                    $(document.body).off('click', handleTooltipClose);
                }
            }

            $(document.body).on('click', handleTooltipClose);
        });
    },

    voucherErrorCheck: function() {
        var $promoDiv = $('#promoSection');
        if ($promoDiv.length > 0) {

            var $forms = $("#newVouchers .form-group").toArray();
            var $voucherCodeForm = $forms[0] && $($forms[0]);
            var $firstNameForm = $forms[1] && $($forms[1]);
            var $lastNameForm = $forms[2] && $($forms[2]);

            var $iconObj = $('.payment-promo-code-link .icon');
            var voucherCall = $("#voucherBtnClicked").val();
            var appliedVoucher = $("#appliedVoucher").val();

            function renderErrorBox($el, inputId) {
                if ($el.hasClass('has-error')) {
                    ACC.gtm.callWhenLoaded('trackCheckoutErrorGTM', 'Promo_invalid_promo_code');
                    // wrap error input in a div
                    $el.wrap('<div id="error-input-wrap"></div>');
                    // grab a reference to the element that we just created, and give it relative positioning
                    var $wrappedErrorInput = $el.find('#error-input-wrap');
                    $wrappedErrorInput.css('position', 'relative');

                    $el.find('i.icon-cancel-circled.error').css('display', 'block');
                } else {
                    var firstOrLastNameHasErrors = ($firstNameForm && $firstNameForm.hasClass('has-error') || $lastNameForm && $lastNameForm.hasClass('has-error'));

                    if(firstOrLastNameHasErrors) {
                        return;
                    } else if(!firstOrLastNameHasErrors && $voucherCodeForm.hasClass('has-error')) {
                        return;
                    } else {
                        $(inputId).val('');
                    }
                }
            }

            $voucherCodeForm && renderErrorBox($voucherCodeForm, '#voucherCode');
            $firstNameForm && renderErrorBox($firstNameForm, '#firstName');
            $lastNameForm && renderErrorBox($lastNameForm, '#lastName');

            if (appliedVoucher === 'yes'){
                if ($voucherCodeForm.hasClass('has-error')) {
                    $iconObj.removeClass('icon-down-open-big');
                    if($('.global-alerts').length <= 0) {
                        $('html, body').stop().animate({scrollTop: $promoDiv.offset().top -200}, 'slow');
                    }
                } else {
                    $iconObj.removeClass('icon-down-open-big');
                    if (voucherCall === 'true' && $('.global-alerts').length <= 0){
                        $('html, body').stop().animate({scrollTop: $promoDiv.offset().top -200}, 'slow');
                    }
                }
            } else {
                if ($voucherCodeForm && $voucherCodeForm.hasClass('has-error')) {
                    $iconObj.removeClass('icon-down-open-big');
                    if($('.global-alerts').length <= 0) {
                        $('html, body').stop().animate({scrollTop: $promoDiv.offset().top -200}, 'slow');
                    }
                }
            }
        }
    },

    trackPostcodeError: function() {
		$('#address-postcode').blur(function(){
			if ($('#address-postcode').parent('.form-group').hasClass('has-error')){
                var error;
				if (window.location.href.indexOf("delivery-method") > -1) {
                    error = 'dlvr_postcode_error';
				} else if (window.location.href.indexOf("choose-payment-method") > -1){
                    error = 'bill_postcode_error';
				}
                ACC.gtm.callWhenLoaded('trackCheckoutErrorGTM', error);
			}
		});
	},

    /**
     * @description conditionally show extra input fields based on the type of
     * the entered voucherCode; if the user is authenticated & enters a AIN code,
     * then render first & last name inputs and append them to the form;
     * the AIN code always starts with 'TJX'.
     * AIN code has between 6 and 9 digits after `TJX`, so a max length of 12 ch
     */
    checkPromoCode: function() {

        if ($('#newVouchers').length) {
            var $voucherCodeForm = $($("#newVouchers .form-group").toArray()[0]);
            var $voucherCredentials = $('.js-newVoucher-AIN').clone();

            function isAINVoucher(voucher) {
                return voucher.toUpperCase().lastIndexOf('TJX', 0) === 0;
            }

            // if the code was previously submitted, but has errors, the input will be already populated
            if ( isAINVoucher( $('#voucherCode').val() ) ) {
                // if AIN has errors, show the extra inputs
                if($voucherCodeForm.hasClass('has-error')) {
                    $('.js-newVoucher-AIN').removeClass('hidden');
                }

                // if any of the extra inputs has errors, show them
                $('.js-newVoucher-AIN .form-group').toArray().forEach(function(form) {
                    if($(form).hasClass('has-error')) {
                        $('.js-newVoucher-AIN').removeClass('hidden');
                    }
                });
            } else {
                if (!$voucherCodeForm.hasClass('has-error')) {
                    $('#voucherCode').val('');
                }
            }

            document.querySelector('#newVouchers #voucherCode').addEventListener('input', function(e) {
                if ( isAINVoucher(e.target.value) ) {

                    $('.js-newVoucher-AIN').remove();
                    $('#voucherCode').attr('maxlength', 12);
                    $voucherCredentials.insertBefore($('#apply-new-voucher-btn'));
                    $('.js-newVoucher-AIN').removeClass('hidden');

                } else {
                    $('#voucherCode').removeAttr('maxlength');
                    $('.js-newVoucher-AIN').remove();
                }
            });
        }
    },

    // If JSP switch is showing we should open page with Gift tab exposed.
    activateGiftCardTab: function() {
        var CS = ACC.checkoutsteps;
        var c = CS._constants;
        $(c.SELECTOR_GIFT_TAB).click();
        $(c.SELECTOR_PROMO_SECTION).show();
    },

    initClickAndCollect: function() {
        var CS = ACC.checkoutsteps;
        var c = CS._constants;

        CS.addStorefinderResultsPreFilter();
        CS.cacheClickAndCollectElements();
        CS.setDeliverySelectionView();
        CS.bindClickAndCollectEvents();
        CS.bindStoreFinderFormEvents();
        CS.bindStoreListEvents();
        CS.bindStoreDetailsEvents();
        CS.bindCollectionDetailsValidation(c.SELECTOR_CANDC_DETAILS_FORM, c.SELECTOR_CANDC_DETAILS_BUTTON, true);

        // Let the search know we only want CandC stores.
        ACC.storefinder._cache.storeSearchExtraParams = "&criteria=cc";
    },

    initCollectionPoint: function() {
        var CS = ACC.checkoutsteps;
        var c = CS._constants;

        CS.bindCollectionDetailsValidation(c.SELECTOR_CP_DETAILS_FORM, c.SELECTOR_CP_DETAILS_BUTTON);
    },

    // A Little extra handling for CandC, when we get store results.
    addStorefinderResultsPreFilter: function() {
        ACC.storefinder.options.storesResultsPreFilter = function() {
            var CS = ACC.checkoutsteps;
            var cache = ACC.storefinder._cache;
            var $message = cache.$storeFinderFormError.find(".message");

            if (cache.storesresults < 1) {
                $message.text(cache.text.noCandcStoresFound.replace(/\{2\}/, cache.location));
                cache.$storeFinderFormError.show();

                if (CS._cache.$candcDetails.hasClass(CS._constants.CLASS_VISIBLE)) {
                    CS._cache.$candcDetails.removeClass(CS._constants.CLASS_VISIBLE);
                }
                if (CS._cache.$storeFinderList.hasClass(CS._constants.CLASS_VISIBLE)) {
                    CS._cache.$storeFinderList.removeClass(CS._constants.CLASS_VISIBLE);
                }

                ACC.gtm.callWhenLoaded( 'trackCheckoutErrorGTM' , 'CandC_no_store_in_this_radius' );
            }
        };
    },

    cacheClickAndCollectElements: function() {
        var CS = ACC.checkoutsteps;
        var cache = CS._cache;
        var c = CS._constants;

        cache.$addressForm = $(c.SELECTOR_ADDRESS_FORM);
        cache.$storeSearch = $(c.SELECTOR_STORE_SEARCH);
        cache.$candcDetails = $(c.SELECTOR_CANDC_DETAILS);
        cache.$selectedStore = $(c.SELECTOR_SELECTED_STORE);
        cache.$candcDetailsForm = $(c.SELECTOR_CANDC_DETAILS_FORM);
        cache.$deliveryDetails = $(c.SELECTOR_HOME_DELIVERY_DETAILS);
        cache.$storeFinderList = $(c.SELECTOR_STORE_FINDER_LIST);
        cache.$parcelShopDetails = $(c.SELECTOR_PARCEL_SHOP_BLOCK);
        cache.$cpDetailsForm = $(c.SELECTOR_CP_DETAILS_FORM);

        // Set any text detected in JSP in cache.text.
        // Running this after Stores List initialisation to make sure
        // we can override the Stores List Components own text.
        ACC.global.setDataElementText(cache.text, cache.$storeSearch);
        cache.$selectedDeliveryType = $(c.SELECTOR_SELECTED_DELIVERY_TYPE);
    },

    bindStoreFinderFormEvents: function() {
        var CS = ACC.checkoutsteps;
        var SF_cache = ACC.storefinder._cache;

        // Add extra alterations required for Click and Collect view reset.
        // Note: Due to complications with poor script loading order, need
        // to wait for ACC.storefinder stuff before we can hook into it.
        $(document).on("ACC.storefinder.initStoreFinderComponent.complete", function() {
            SF_cache.$storeFinderForm.on("submit", function() {
                CS._cache.$selectedStore.val(""); // Reset
                ACC.gtm.callWhenLoaded('trackCheckoutStepOptions', '1', 'Store Search');
            });

            var entry = $("#storelocator-query").val();
            if (entry.length > 0) {
                $("#storeFinderForm").submit();
            }
        });
    },

    // Set the view state according to selected delivery method.
    setDeliverySelectionView: function() {
        var CS = ACC.checkoutsteps;
        var cache = CS._cache;
        var c = CS._constants;

        var $candcRadio = $(c.SELECTOR_CLICK_AND_COLLECT, cache.$addressForm).find("input");
        var $deliveryRadio = $(c.SELECTOR_HOME_DELIVERY, cache.$addressForm).find("input");
        var $parcelShopRadio = $(c.SELECTOR_PARCEL_SHOP, cache.$addressForm).find("input");

        if($candcRadio.is(":checked")) {
            cache.$storeSearch.addClass(c.CLASS_VISIBLE);
            cache.$selectedDeliveryType.val($candcRadio.val());
        } else if($deliveryRadio.is(":checked")) {
            cache.$deliveryDetails.addClass(c.CLASS_VISIBLE);
            cache.$selectedDeliveryType.val($deliveryRadio.val());
        } else if($parcelShopRadio.is(":checked")) {
            cache.$parcelShopDetails.addClass(c.CLASS_VISIBLE);
            cache.$selectedDeliveryType.val($parcelShopRadio.val());
        }
    },

    bindClickAndCollectEvents: function() {

        // CHANGE FOR AJAX CALL - TJX-1758
        //var CS = ACC.checkoutsteps;
        //var cache = CS._cache;
        //var c = CS._constants;
        //var url = location.href.replace(/(.*\/checkout\/multi\/delivery-method\/)(choose|select).*/, "select?delivery_method=");
        /*
        // Opens the Store search form
        cache.$addressForm.on('click', c.SELECTOR_CLICK_AND_COLLECT, function(e) {
            location.href = url + "clickAndCollect";
        });

        // Closes the Store search form
        cache.$addressForm.on('click', c.SELECTOR_HOME_DELIVERY, function(e) {
            location.href = url + "delivery";
        });
        */

    },

    bindStoreListEvents: function() {
        // Because scripts aren't loaded in required order. We need to
        // wait for ACC.storefinder stuff before we can hook into it.
        $(document).on("ACC.storefinder.initStoreListComponent.complete", function() {
            var CS = ACC.checkoutsteps;

            // Due to script timing and lack of dependency injection,
            // need to set the required text alterations here.
            ACC.storefinder._cache.storelist.$control.text(ACC.checkoutsteps._cache.text.showMoreStores);

            // Bind to the store list created event to add what we need for click and collect.
            ACC.storefinder._cache.storelist.$container.on("created", function() {
                CS.addStoreSelectors();
                CS.bindStoreItemSelection();
                CS.activateFirstOrSavedStoreItemSelector();

                if (!CS._cache.$candcDetails.hasClass(CS._constants.CLASS_VISIBLE)) {
                    CS._cache.$candcDetails.addClass(CS._constants.CLASS_VISIBLE);
                }

                if (!CS._cache.$storeFinderList.hasClass(CS._constants.CLASS_VISIBLE)) {
                    CS._cache.$storeFinderList.addClass(CS._constants.CLASS_VISIBLE);
                }

                // Event is triggered when control activated is 'show more' button.
                ACC.storefinder._cache.storelist.$container.on("click", ".showMoreStores", function () {
                    CS.bindStoreItemSelection();
                });
            });

            /*
                STORES_LIST_VIEW_LIMIT:
                Stores list restriction covered by TJX-2015, but the
                functionality is built in to the list component.
                Have stopped short of implementing the count display
                as that work will be in TJX-2015
            */
            ACC.storefinder.options.storesListViewLimit = CS._constants.STORES_LIST_VIEW_LIMIT;
        });
    },

    // Change existing StoreList items to fit an input:radio layout for selection.
    addStoreSelectors: function() {
        var CS = ACC.checkoutsteps,
            cache = CS._cache,
            $list = ACC.storefinder._cache.storelist.$container,
            $storeList = $list.find('ol:not(.clone)').find('li'),
            storesCount = $storeList.length;

        cache.$storeSelectors = $(); // Make sure it is cleared.

        $storeList.each(function(i) {
            var $this = $(this),
                storeId = $this.data("storeid"),
                elementId = "candcstore_" + i,
                $input = $('<input name="candcstore" id="' + elementId + '" value="' + storeId + '" type="radio" />'),
                $moreDetailsBtn = $this.find('.moreDetails');

            // Capture input for later use.
            cache.$storeSelectors = cache.$storeSelectors.add($input);

            // Creating aria-label as distance is outside of store details, ensuring it is read in one go 
            let storeInformationAriaLabel = $.trim(
                ($this.find('.store-details').text() + ' ' + $this.find('.distance').text()));
 
            // Replace unwanted elements and add $input support.
            $this.find('.indicator').replaceWith($input);
            $this.find('.store-details').wrap('<label for="' + elementId + '" aria-hidden="true"></label>');
            $this.find('.details').remove();
            $this.find('.moreDetails').remove();
            $input.attr('aria-label', storeInformationAriaLabel);
 
            // Ensuring the more details button is read separately
            $this.removeAttr('role');
            $this.wrapInner('<div class="clr form-group global-radio-button row"></div>');

            // Distance is already being read out by screenreader so it is hidden here
            $this.append($this.find('.distance').attr('aria-hidden', 'true'));
            $this.append($moreDetailsBtn);
        });

        // keep below outside of default selected block above
        if (!$('.delivery-store').hasClass('selected') || storesCount === 0) {
            return;
        }

        $storeList.each(function(i){
            var $thisLi = $(this),
                countLi = i + 1;

            if ($thisLi.find('input.selected').length) {

                if ($thisLi.hasClass('concealed')) {
                    for (i = 0; i < countLi; i++) {
                        $storeList.eq(i).removeClass('concealed').addClass('revealed');
                    }

                    var $storeListReporter = $('#storeFinderList').find('.reporter span');
                    // change the value first
                    $storeListReporter.eq(3).html(countLi);

                    var listPageCounter = $storeListReporter.eq(3).html();
                    var listPageTotal = $storeListReporter.eq(5).html();

                    if (listPageCounter === listPageTotal) {
                        $('#storeFinderList').find('.showMoreStores').removeClass('visible');
                    }
                }
            }
        });
    },

    // Add vaue of selected store radio to hidden input in actual form.
    bindStoreItemSelection: function() {
        var $list = ACC.storefinder._cache.storelist.$container;
        $list.off("click", ".store-details-item .global-radio-button").on("click", ".store-details-item .global-radio-button", function() {
            ACC.gtm.callWhenLoaded('trackCheckoutStepOptions', '1', 'click and collect - store selection');
            var item = $(this).find('input[type=radio]');
            ACC.checkoutsteps.setSelectedStore(item[0]);
        });
    },

    // Preselect any saved store we might have that matches one in the cached inputs.
    activateFirstOrSavedStoreItemSelector: function() {
        var CS = ACC.checkoutsteps;
        var cache = CS._cache;
        var c = CS._constants;
        var storeToSelect = cache.$storeSelectors[0];
        var savedStoreId = sessionStorage.getItem(c.DATA_SELECTED_STORE);

        cache.$storeSelectors.each(function() {
            if(Number(savedStoreId) === Number(this.value)) {
                storeToSelect = this;
            }
        });

        $(storeToSelect).prop('checked', true);
        ACC.checkoutsteps.setSelectedStore(storeToSelect);
    },

    // Add anything to support CandC Store Details view.
    bindStoreDetailsEvents: function() {
        var $cncSelector = $('#clickAndCollectStoreSelection');
        var $modal = $('#extLinkPopup');
        var $modalDialog = $modal.find('.modal-dialog');
        var $modalContent = $modal.find('.modal-content');

        $cncSelector.on('click', '.moreDetails', function() {
            var jsonUrl = $(this).attr('data-json');

            $modal.attr('aria-labelledby', 'storeNameDetail')
            $modalContent.html('');

            $.getJSON(jsonUrl, function(data) {
                let commentSection = '';
                if (data.stores[0].comment !== '') {
                    commentSection =  `<p class="detailsComments">${data.stores[0].comment}</p>`
                }

                const storeName = data.stores[0].chain === '20' ? `TK Maxx ${data.stores[0].name}` : data.stores[0].name;

                const titleSection = `<div class="detailSection">
                    <h2 id="storeNameDetail" data-store-name="${storeName}">${storeName}</h2>
                    <p class="detailsAddress">${data.stores[0].address}, ${data.stores[0].address2}, ${data.stores[0].zip}</p>
                    ${commentSection}
                </div>`

                const openingHoursArray = data.stores[0].hours.split('<br>');
                let openingHoursSection = '';
                let openingDaysList = '';

                $.each(openingHoursArray, function(index, value) {
                    const [day, time] = value.trim().split(' : ')
                    const displayTime = (!time || time === 'undefined') ? 'Closed' : time;

                    if (day) {
                        openingDaysList += `
                            <li class="row">
                                <span class="col-xs-6">${day}:</span>
                                <span>${displayTime}</span>
                            </li>
                        `;
                    }
                });

                if (data.stores[0].hours !== '') {
                    openingHoursSection = `
                    <div class="detailSection">
                        <h3 id="openingTimesTitle" class="openingTimesTitle">${ACC.checkoutsteps._cache.text.openingTimes}</h3>
                        <ul id="openingTime" aria-labelledby="openingTimesTitle">
                            ${openingDaysList}
                        </ul>
                    `
                }

                $modalDialog.addClass('small');
                $modalContent.html(`
                    <div id="storeDetail">
                        <div class="detailPane">
                           ${titleSection}
                           ${openingHoursSection}
                        </div>

                        <div class="storeDetailMap">
                            <h3 class="mapTitle">${ACC.checkoutsteps._cache.text.mapTitle}</h3>
                            <div
                                id="map_canvas"
                                style="width:900px;height:580px"
                                data-latitude = "${data.stores[0].latitude}"
                                data-longitude = "${data.stores[0].longitude}"
                                data-stores= '{"id":"0","latitude":"${data.stores[0].latitude}","longitude":"${data.stores[0].longitude}","name":""}'
                            ></div>
                        </div>
                    </div>
                `);

                ACC.global.addGoogleMapsApi('ACC.storedetail.drawMapMain');
            });
        });

        $modal.on('hidden.bs.modal', function() {
            $modal.removeAttr('aria-labelledby');
            $modalDialog.removeClass('small');
        });
    },

    // Because the normal validation moves away from the page, we lose all
    // record of view state (JS is reset). This causes issues with return to
    // page on error. To prevent lots of BE + FE changes to capture and reinisialise
    // to last state, we're simply going to check for empty values and prevent
    // form submission if that's the case. User will have to start again if they
    // add nonsense to the form.
    bindCollectionDetailsValidation: function(formSelector, btnSelector, isCC) {
        var $tjxClickCollectForm = $(formSelector);
        var CS = ACC.checkoutsteps;
        var cache = CS._cache;

        // Validate the collection details input fields prior to submit
        $tjxClickCollectForm.on('click', btnSelector, function(e) {
            var $inputs = $tjxClickCollectForm.find('.form-control');

            $inputs.each(function() {
                var $input = $(this);
                if ($input.attr('data-mandatory') === 'true') {
                    ACC.validation.validateInput($input, ACC.validation.inputFieldErrorViewHandler);
                }
            });
        });

        if (isCC) {
            // Form validation.
            cache.$candcDetailsForm.on("submit", function() {
                // If no store selected, use first one in list.
                if(!cache.$selectedStore.val()) {
                    CS.setSelectedStore(cache.$storeSelectors.get(0));
                }
                return CS.candcDetailValid();
            });
        } else {
            // Form validation.
            cache.$cpDetailsForm.on("submit", function() {
                // If no store is selected by user, the first option in the list will be chosen by Vue by default.
                return CS.cpDetailValid();
            });
        }
    },

    setCollectionPointDetails(shopDetails) {
        $.each(shopDetails, (key, value) => {
            $('#cpCollectionDetailsForm .storeAddress input[name="' + key + '"]' ).val(value);
        })
    },

    displayCollectionPointDetailsForm(display) {
        if (display) {
            $('#cpCollectionDetailsForm').addClass('visible');
        } else {
            $('#cpCollectionDetailsForm').removeClass('visible');
        }
    },

    /**
     * When loading the Delivery section, if one of the delivery methods(delivery or click and collect or parcel shop)
       is pre-selected, then we trigger 'checkout_option' event.
       Additionally, if the pre-selected delivery method is home delivery, then we also
       trigger 'checkout_option' for the pre-selected delivery option.
     */

    triggerPreselectedDeliveryEvent: function () {
        var CS = ACC.checkoutsteps;
        var cache = CS._cache;
        var c = CS._constants;
        var $candcRadio = $(c.SELECTOR_CLICK_AND_COLLECT, cache.$addressForm).find("input");
        var $deliveryRadio = $(c.SELECTOR_HOME_DELIVERY, cache.$addressForm).find("input");
        var $parcelShopRadio = $(c.SELECTOR_PARCEL_SHOP, cache.$addressForm).find("input");

        if ($candcRadio.is(":checked")) {
            ACC.gtm.callWhenLoaded('trackCheckoutStepOptions', '1', 'click and collect');
        } else if ($deliveryRadio.is(":checked")) {
            ACC.gtm.callWhenLoaded('trackCheckoutStepOptions', '1', 'delivery');

            var $visibleDelOptionBox = $('.checkout-delivery-home .checkout-delivery-option-block').is(':visible');
            if ($visibleDelOptionBox) {
                CS.triggerPreselectedDeliveryOption();
            }
        } else if ($parcelShopRadio.is(":checked")) {
            ACC.gtm.callWhenLoaded('trackCheckoutStepOptions', '1', 'parcel shop');
        }
    },

    /**
     * Method used to trigger event for the pre-selected delivery option.
     */
    triggerPreselectedDeliveryOption: function() {
        var $deliveryOptions = $('.checkout-delivery-option-list li');

        $deliveryOptions.find('input[name="shippingMethodCode"]').each(function () {
            var $option = $(this);
            if ($option.is(':checked')) {
                var preselectedOption = $option.data('deliveryname');
                ACC.gtm.callWhenLoaded('trackCheckoutStepOptions', '1', preselectedOption);
            }
        });
    },

    // Records the selected store value.
    // Default is selected if none passed.
    // @store (HTML node) Radio input for a store selection.
    setSelectedStore: function(store) {
        var CS = ACC.checkoutsteps;
        var value = store.value;
        CS._cache.$selectedStore.val(value);
        window.sessionStorage.setItem(CS._constants.DATA_SELECTED_STORE, value);
    },

    // Clear persisted store selection so not remembered across pages.
    clearSelectedStore: function() {
        var CS = ACC.checkoutsteps;
        window.sessionStorage.setItem(CS._constants.DATA_SELECTED_STORE, "");
    },

    // Simple validation to minimise chance of user returning to
    // page with error message (and uninitialised view)
    candcDetailValid: function() {
        var VA = ACC.validation;
        var firstValid = VA.name($("#click-collect-address-firstName"), VA.inputFieldErrorViewHandler);
        var secondValid = VA.name($("#click-collect-address-surname"), VA.inputFieldErrorViewHandler);
        var phoneValid = VA.candcPhoneInput($("#click-collect-address-mobile"));
        return  firstValid && secondValid && phoneValid;
    },

    cpDetailValid: function() {
        var VA = ACC.validation;
        var firstValid = VA.name($("#cp-address-firstName"), VA.inputFieldErrorViewHandler);
        var secondValid = VA.name($("#cp-address-surname"), VA.inputFieldErrorViewHandler);
        var phoneValid = VA.candcPhoneInput($("#cp-address-mobile"));
        return  firstValid && secondValid && phoneValid;
    },

    bindBillingAddressSubmit : function()
    {
        $(document).on("click", ".billing-address-save", function (e) {
            if (document.getElementById('tjxWpBillingAddressForm')) {
                ACC.gtm.trackCheckoutStepOptions('2', 'add billing address', '', 'tjxWpBillingAddressForm');
            } else if (document.getElementById('tjxPaymentsBillingAddressForm')) {
                ACC.gtm.trackCheckoutStepOptions('2', 'add billing address', '', 'tjxPaymentsBillingAddressForm');
            }
        });
    },

    // check if there is Gift Card info message
    // in case yes show it in the correct place and scrollTop the page
    checkGifCardError: function() {
        var CS = ACC.checkoutsteps;
        var c = CS._constants;

        var giftCardErrMsg = $(c.CHECKOUT_SUMMARY_BOX + ' .errorMsg').html();
        var giftCardErrMsgHtml = $(c.CHECKOUT_SUMMARY_BOX).html();
        // check if the message is empty
        if (giftCardErrMsg) {
            $('.main-content .global-message-container').html(giftCardErrMsgHtml);
            $(window).scrollTop(0);
        }
    },

    checkAddressBillId: function() {
        var isBillAddressOpen = $('#billingWrapper').length;
        if (isBillAddressOpen > 0) {
            var addressBillId = Cookies.get('addressBillId');
            if (addressBillId) {
                $('input[value='+addressBillId+']').trigger('click');
                Cookies.remove('addressBillId');
            }
        }
    },

    /**
     * Handler for gift card submit buttons. There are two: check balance, and apply gift card
     * Since there is only one form, the action is switched if the check balance button is clicked
     * as Apply Gift Card is the default action for this form
     *
     * @param e event
   */
    giftCardFormHandler: function(e) {
        e.preventDefault();

        var $this = $(this);
        var $newGiftCardForm = $('#newGiftCard');
        var numOfVisibleCards = $("div[id^='div-giftCard-']:visible").length;
        var recaptchaEnabled = $("#recaptchaEnabled").val();
        var giftCardUrl = $("#giftCardUrl").val();
        var checkBalanceGiftCardUrl = $("#checkBalanceGiftCardUrl").val();

        if (numOfVisibleCards > 0) {
            if ($this.hasClass("checkBalanceButton")) {
                $newGiftCardForm.attr('action', checkBalanceGiftCardUrl);
            }
            else {
                $newGiftCardForm.attr('action', giftCardUrl);
            }
            if (recaptchaEnabled == "true") {
                window.ACC.recaptcha.execute({siteKey: window.ACC.config.captchaSiteKeyV3, verifyCallback: window.ACC.recaptcha.giftCardVerifyCallback, action: 'giftcard'});
            }
            else {
                ACC.checkoutsteps.submitGiftCardForm();
            }
        }
    },

    submitGiftCardForm: function() {
        var $newGiftCardForm = $('#newGiftCard');
        sessionStorage.setItem('displayBanner', 'gift');
        $newGiftCardForm.submit();
    },

    // deprecated
    showRecaptchaError: function(e) {
        $("#recaptcha").addClass("has-error-border");
        $(".gift-card-captcha .has-error").show();
    },

    // deprecated
    hideRecaptchaError: function(e) {
        $("#recaptcha").removeClass("has-error-border");
        $(".gift-card-captcha .has-error").hide();
    },

    /**
     * Initialises gift card button handlers, both Check Balance and Apply Gift Card
     */
    initGiftCardHandlers: function() {
        var $document = $(document);
        $document.on("click", "#checkBalanceButton, #applyButton", this.giftCardFormHandler);
        var isRecaptchaEnabled = $("#recaptchaEnabled").val();
        if (isRecaptchaEnabled == "true") {
            window.ACC.recaptcha.loadScript();
        }
    },

    /**
     * @description this methods checks if addressId exists in the
     * list of address entries and selects it, if true.
     * the 'addressEntry' class can be found in the delivery &
     * payment checkout pages and contains the list of saved addresses.
     * @param {addressId} id to be looked for and selected
     */
    selectAddressEntry: function(addressId) {
        var addressEntries = [];
        $('.addressEntry input[type="radio"]').each(function() {
            addressEntries.push($(this).attr('value'));
        });
        var index = addressEntries.indexOf(addressId);
        if (index !== -1) {
            $('.addressEntry input[type="radio"]').each(function(){
                $(this).removeAttr('checked', 'checked');
                $(this).prop('checked', false);
                $(this).removeClass('checked');
                if ($(this).attr('value') == addressId){
                    $(this).attr('checked', 'checked');
                    $(this).prop('checked', true);
                }
            })
        }
    },

    /**
     * this method fixes the back-forward cache bug in the checkout process
     * description: 2 delivery addresses are checked if you go back from billing&payment to delivery page
     */
    bindBFCache: function() {
        $(window).on('load', function(event) {
            var isBack = sessionStorage.getItem('visitedBilling');
            var selectedDeliveryAddressId = sessionStorage.getItem('selectedDeliveryAddressId');
            var selectedBillingAddressId = sessionStorage.getItem('selectedBillingAddressId');

            if (window.location.href.indexOf('choose-payment-method') > 0 && selectedBillingAddressId) {
                sessionStorage.setItem('visitedBilling','true');

                if (selectedBillingAddressId != 'default') {
                    ACC.checkoutsteps.selectAddressEntry(selectedBillingAddressId);
                }
            }
            if(window.location.href.indexOf('delivery-method/choose') > 0 && window.location.href.indexOf('edit=true') < 0){
                if (isBack && selectedDeliveryAddressId){
                    ACC.checkoutsteps.selectAddressEntry(selectedDeliveryAddressId);
                    $('.checkout-delivery-add-address #i18nAddressForm input').each(function (){
                        $(this).val('');
                    });
                }
            }
        })
        if (window.location.href.indexOf('choose-payment-method') > 0)
        {
            $('.checkout-payment-cta-block button.c-btn--primary, .footer-terms-checkout a, .site-logo a').on("click", function(event){
                sessionStorage.removeItem('selectedDeliveryAddressId');
                sessionStorage.removeItem('selectedBillingAddressId');
                sessionStorage.removeItem('visitedBilling');
            })
        }
    },

    removeParcelShopSessionDetails() {
        if (window.location.pathname.includes('login') || window.location.pathname.includes('orderConfirmation')) {
            sessionStorage.removeItem('parcel-shop-results');
            sessionStorage.removeItem('selected-parcel-shop');
            sessionStorage.removeItem('parcel-shop-search-query');
        }
    },

    /**
     * @description Checks if the order notification banner should be displayed or not.
     * The banner should be displayed if any promo code/associate discount/gift card has been
     * successfully applied during the current page load.
     */
    displayFlashBanner() {
        const displayBanner = sessionStorage.getItem('displayBanner');
        const giftCardApplied = $('#newGiftCard .has-error').length == 0 && displayBanner == 'gift';
        const promoCodeApplied = $('#voucherCode.form-error').length == 0 && displayBanner == 'promo';
        const gCpCRemoved = displayBanner == 'remove';
        if (giftCardApplied || promoCodeApplied || gCpCRemoved) {
            sessionStorage.removeItem('displayBanner');
            ACC.checkoutsteps.setFlashBannerTimer();
        }
    },

    flashBannerTimeoutId: 0,

    setFlashBannerTimer() {
        ACC.checkoutsteps.cancelFlashBannerTimer();
        const timer = ACC.orderNotificationFlashBannerTimer;
        const banner = document.getElementById('orderSummaryBanner');

        if (timer && timer > 0 && banner) {
            banner.classList.remove('hide');
            ACC.checkoutsteps.flashBannerTimeoutId = setTimeout(()=> {
                    banner.classList.add('hide');
            }, timer)
        }
    },

    cancelFlashBannerTimer() {
        clearTimeout(ACC.checkoutsteps.flashBannerTimeoutId);
    },

    voucherCodeErrorCircleResize: function () {
        const newVouchers = document.getElementById("newVouchers");
        if (!newVouchers) return;

        const voucherCodeErrors = document.getElementById('voucherCode.errors');
        if (!voucherCodeErrors) return;

        const voucherCodeErrorsHeight = voucherCodeErrors.offsetHeight;
        const iconError = newVouchers.getElementsByClassName('icon-cancel-circled error');

        const label = newVouchers.getElementsByTagName('label');
        const labelHeight = label[0].offsetHeight;

        if (voucherCodeErrorsHeight > '15' && iconError.length > 0) {
            if (labelHeight > '20') {
                iconError[0].style.top = '51px';
            } else {
                iconError[0].style.top = '32px';
            }
        }
    }
};


$(document).ready(function () {
    var $logoAnchor = $(".page-orderConfirmationPage #site-logo a");
    if ($logoAnchor && $logoAnchor.length) {
        $logoAnchor.attr("aria-label", "TK Maxx Logo");
        $logoAnchor.attr("title", "TK Maxx Logo");
    }
    ACC.checkoutsteps.voucherCodeErrorCircleResize();
    window.addEventListener("resize", ACC.checkoutsteps.voucherCodeErrorCircleResize);
});

window.addEventListener("pageshow", function () {
        const logos = document.querySelectorAll(".page-orderConfirmationPage .site-logo a");

        logos.forEach(logo => {
            if(logo) {
                logo.setAttribute("tabindex", "0");

                // Delay focus so NVDA announcesit
                this.setTimeout(() => {
                    logo.focus();
                }, 500); 
            } else {
                logo.removeAttribute("tabindex");
            }
        });
});
